package com.bikompanion.data.cache

import dev.zacsweers.metro.BindingContainer
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import com.bikompanion.domain.di.AppScope

/**
 * Binds the one durable store everything else persists through.
 *
 * Unscoped: an implementation is a file path or a `localStorage` reference with no state of
 * its own, so handing out a fresh one per injection costs nothing and they all address the
 * same underlying storage.
 */
@ContributesTo(AppScope::class)
@BindingContainer
object CacheProviders {
    @Provides
    fun provideLocalStore(): LocalStore = createLocalStore()
}
